import React from "react";
import { TwoRow } from "../../core/layouts";
import { Text, Tag } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";

const ViewUserEmailsAndDnsdDetailsContainerStyle = {
  additionalEmailText: {
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
  },
  dnsdAddressHeaderStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightNormal,
    fontWeight:variables.fontWeightBold,
    color: variables.textDefault,
  },
  dnsdAddressTextStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    color: variables.textDefault,
  },
  twoRowStyle: {
    gap: variables.gapMedium2,
  },
  emailAndDnsdWrapperStyle: {
    gap: variables.gapXS3,
  },
  tagStyle: {
    borderRadius: variables.radiusLg2,
    lineHeight: variables.lineHeightNormal,
    fontWeight: variables.fontWeightNormal,
    color: variables.textDefault,
    padding: `${variables.paddingXSmall} ${variables.paddingSmall}`,
    height: "2rem",
    alignItems: variables.alignCenter,
    justifyContent: variables.spaceBetween,
    background: variables.lightCraftingBlue,
    border: variables.tagBorder,
    fontSize: variables.fontSizeSmall,
    marginBottom: variables.marginSmallest,
    marginRight: variables.marginSmall,
  },
  otherEmailContainerStyle: {
    marginTop: variables.marginMediumLarge,
  },
};

export default function ViewUserEmailsAndDnsdDetailsContainer({
  otherEmail,
  address,
}) {
  const intl = useIntl();
  return (
    <TwoRow
      style={ViewUserEmailsAndDnsdDetailsContainerStyle.twoRowStyle}
      topSection={
        otherEmail?.length > 0 && (
          <TwoRow
            style={
              ViewUserEmailsAndDnsdDetailsContainerStyle.emailAndDnsdWrapperStyle
            }
            topSection={
              <Text
                style={
                  ViewUserEmailsAndDnsdDetailsContainerStyle.additionalEmailText
                }
              >
                {getLocalizedMessage(intl,"address.additionalEmailId.text")}
              </Text>
            }
            bottomSection={
              <div>
                {otherEmail?.map((email) => (
                  <Tag
                    color={variables.lightCraftingBlue}
                    style={ViewUserEmailsAndDnsdDetailsContainerStyle.tagStyle}
                  >
                    {email}
                  </Tag>
                ))}
              </div>
            }
          />
        )
      }
      topSectionStyle={{
        ...(otherEmail?.length > 0 &&
          ViewUserEmailsAndDnsdDetailsContainerStyle.otherEmailContainerStyle),
      }}
      bottomSection={
        address?.length > 0 && (
          <TwoRow
            style={
              ViewUserEmailsAndDnsdDetailsContainerStyle.emailAndDnsdWrapperStyle
            }
            topSection={
              <Text
                style={
                  ViewUserEmailsAndDnsdDetailsContainerStyle.dnsdAddressHeaderStyle
                }
              >
                {getLocalizedMessage(intl,"address.dnsd.text")}
              </Text>
            }
            bottomSection={
              <Text
                style={
                  ViewUserEmailsAndDnsdDetailsContainerStyle.dnsdAddressTextStyle
                }
              >
                {address}
              </Text>
            }
          />
        )
      }
    />
  );
}
